import React, { useContext } from "react";
import { EditorBinding, EditorContext } from "../../../utils/contexts";
import CollapsedPanel from "../components/CollapsedPanel";
import Switcher from "../components/Switcher";
import { Label } from "../Steps/components";
import SubheadlineQuill from "../components/SubheadlineQuill";

export default function Subheadline1Panel() {
  const { settings, updateSettings } = useContext(EditorContext);

  const toggleHide = () => {
    updateSettings({ show_optional_caption: !settings.show_optional_caption });
  };

  const editorBindings = useContext(EditorBinding);
  const isTechAdvisorPlus = settings.theme_id === "tech-advisor-plus";

  return (
    <CollapsedPanel open={editorBindings.showCaption} title="Subheadline 1" allowed={true}>
      <Label>
        <span>Show</span>
        <Switcher checked={settings.show_optional_caption} onChange={toggleHide} />
      </Label>
      {settings.show_optional_caption && isTechAdvisorPlus && (
        <SubheadlineQuill
          value={settings.caption}
          onChange={(content) => updateSettings({ caption: content })}
        />
      )}
    </CollapsedPanel>
  );
}
